import React from 'react';
import Location from './Location.jsx';
import AdminImageUploader from './AdminImageUploader.jsx';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomeScreen from './HomeScreen.jsx';
import LoginScreen from './LoginScreen.jsx';
import RegisterScreen from './RegisterScreen.jsx';
import AdminDashboard from './AdminDashboard.jsx';
import AdminHiringDocuments from './AdminHiringDocuments.jsx';
import AdminUploader from './AdminUploader.jsx';
import VehicleList from './VehicleList.js';
import HiringList from './HiringList.jsx';
import HiringViewer from './HiringViewer.jsx';
import AdminHiringContent from './AdminHiringContent.jsx';
import ClientHiring from './Client_Hiring.jsx';
import AdminLeaseToOwnDocuments from './AdminLeaseToOwnDocuments.jsx';
import LeaseToOwnList from './LeaseToOwn.jsx';
import LeaseToOwnViewer from './LeaseToOwnViewer.jsx';
import HiringAgreementView from './HiringAgreementView.jsx';
import LeaseToOwnAgreementView from './LeaseToOwnAgreementView.jsx';
import CompanyBackground from './About_Us.jsx';
import CompanyImagesAdmin from './Companyimagesadmin.jsx';
import PrivacyPolicy from './Privacy.jsx';
import TermsOfService from './Terms.jsx';
import AirportAdmin from './AirportAdmin.jsx';
import AirportServiceViewer from './AirportServiceViewer.jsx';

// ─── Protected Route ───────────────────────────────────────────────────────────
const ALLOWED_EMAILS = [
  'arjunmongar45@gmail.com',
  'marketing@sangaytsheltrim.com'
];

function ProtectedRoute({ children }) {
  const isLoggedIn  = localStorage.getItem('isLoggedIn')  === 'true';
  const authToken   = localStorage.getItem('authToken')   === 'true';
  const authMethod  = localStorage.getItem('authMethod');
  const userEmail   = localStorage.getItem('userEmail');

  // Not logged in at all
  if (!isLoggedIn || !authToken) {
    return <Navigate to="/stmotor-admin-login" replace />;
  }

  // Google users must be on the whitelist
  if (authMethod === 'google' && !ALLOWED_EMAILS.includes(userEmail)) {
    localStorage.clear();
    return <Navigate to="/stmotor-admin-login" replace />;
  }

  return children;
}
// ───────────────────────────────────────────────────────────────────────────────

function App() {
  return (
    <Router>
      <Routes>

        {/* ── Public routes ───────────────────────────────────────────── */}
        <Route path="/"                                element={<HomeScreen />} />
        <Route path="/stmotor-admin-login"             element={<LoginScreen />} />
        <Route path="/register"                        element={<RegisterScreen />} />
        <Route path="/locations"                       element={<Location />} />
        <Route path="/company-background"              element={<CompanyBackground />} />
        <Route path="/privacy-policy"                  element={<PrivacyPolicy />} />
        <Route path="/terms-of-service"                element={<TermsOfService />} />
        <Route path="/hiring-agreement-view"           element={<HiringAgreementView />} />
        <Route path="/lease-to-own-agreement-view"     element={<LeaseToOwnAgreementView />} />
        <Route path="/client-hiring"                   element={<ClientHiring />} />
        <Route path="/HiringViewer"                    element={<HiringViewer />} />
        <Route path="/lease-to-own-viewer"             element={<LeaseToOwnViewer />} />
        <Route path="/vehicles"                        element={<VehicleList />} />
        <Route path="/airport-service"                 element={<AirportServiceViewer />} />

        {/* ── Protected routes ────────────────────────────────────────── */}
        <Route path="/admin-dashboard" element={
          <ProtectedRoute><AdminDashboard /></ProtectedRoute>
        } />
        <Route path="/upload" element={
          <ProtectedRoute><AdminUploader /></ProtectedRoute>
        } />
        <Route path="/hirings" element={
          <ProtectedRoute><HiringList /></ProtectedRoute>
        } />
        <Route path="/lease-to-own" element={
          <ProtectedRoute><LeaseToOwnList /></ProtectedRoute>
        } />
        <Route path="/admin-image-uploader" element={
          <ProtectedRoute><AdminImageUploader /></ProtectedRoute>
        } />
        <Route path="/admin-hiring-documents" element={
          <ProtectedRoute><AdminHiringDocuments /></ProtectedRoute>
        } />
        <Route path="/admin-hiring-content" element={
          <ProtectedRoute><AdminHiringContent /></ProtectedRoute>
        } />
        <Route path="/admin-lease-to-own-documents" element={
          <ProtectedRoute><AdminLeaseToOwnDocuments /></ProtectedRoute>
        } />
        <Route path="/admin-company-images" element={
          <ProtectedRoute><CompanyImagesAdmin /></ProtectedRoute>
        } />
        <Route path="/admin-airport-service" element={
          <ProtectedRoute><AirportAdmin /></ProtectedRoute>
        } />

      </Routes>
    </Router>
  );
}

export default App;